import React, { useEffect, useState } from "react"
import "../../assets/styles/nav/nav-main.scss"

export default function MainNav() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [toogle, setToogle] = useState(false)

  const [submenu, setSubmenu] = useState({
    aboutUs: false,
    ourWork: false,
    learn: false,
    findHelp: false,
    getInvolved: false
  })

  const mobileOnly = windowWidth < 768

  const handleMenuClass = () => {
    if (!mobileOnly) return "nav-main desktop"
    return toogle ? "nav-main mobile show-menu" : "nav-main mobile"
  }

  const handleSubmenu = (submenuItem) => {
    const newState = {
      ...submenu,
      [submenuItem]: !submenu[submenuItem]
    }
    return setSubmenu(newState)
  }

  const handleSubMenuClass = (submenuItem) => submenu[submenuItem] ? "show" : "hide"

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize, false);
  }, []);


  return (
    <>
      {mobileOnly && <button onClick={() => setToogle(!toogle)} className="toogle">Toggle</button>}
      <ul className={handleMenuClass()}>
        <li className="dropdown">
          <a href="https://www.shatterproof.org/about-us">About Us</a>
          {
            mobileOnly &&
            <span
              onClick={() => handleSubmenu("aboutUs")}
              className={handleSubMenuClass("aboutUs")}
            />
          }
          <ul className={handleSubMenuClass("aboutUs")}>
            <li><a href="https://www.shatterproof.org/about-us/our-story" target="_blank" rel="noopener noreferrer">Our Story</a></li>
            <li><a href="https://www.shatterproof.org/our-work" target="_blank" rel="noopener noreferrer">Our Work</a></li>
            <li><a href="https://www.shatterproof.org/about-us/media-room" target="_blank" rel="noopener noreferrer">Media Room</a></li>
            <li><a href="https://www.shatterproof.org/about-us/leadership" target="_blank" rel="noopener noreferrer">Leadership</a></li>
            <li><a href="https://www.shatterproof.org/about-us/staff" target="_blank" rel="noopener noreferrer">Staff</a></li>
            <li><a href="https://www.shatterproof.org/our-partners" target="_blank" rel="noopener noreferrer">Our Partners</a></li>
            <li><a href="https://www.shatterproof.org/careers" target="_blank" rel="noopener noreferrer">Carrers</a></li>
          </ul>
        </li>
        <li>
          <a href="https://www.shatterproof.org/learn/addiction-basics/addiction-in-america">Addition in America</a>
        </li>
        <li className="dropdown">
          <a href="https://www.shatterproof.org/our-work">Our Work</a>
          {
            mobileOnly &&
            <span
              onClick={() => handleSubmenu("ourWork")}
              className={handleSubMenuClass("ourWork")}
            />
          }
          <ul className={handleSubMenuClass("ourWork")}>
            <li><a href="https://www.shatterproof.org/our-work/revolutionizing-addiction-treatment" target="_blank" rel="noopener noreferrer">Revolutionizing addiction treatment</a></li>
            <li><a href="https://www.shatterproof.org/our-work/ending-addiction-stigma" target="_blank" rel="noopener noreferrer">Ending addiction stigma</a></li>
            <li><a href="https://www.shatterproof.org/our-work/educating-and-empowering-communities" target="_blank" rel="noopener noreferrer">Educating and empowering communities</a></li>
            <li><a href="https://www.shatterproof.org/our-work/advocacy" target="_blank" rel="noopener noreferrer">Advocating for change</a></li>
          </ul>
        </li>
        <li className="dropdown">
          <a href="https://www.shatterproof.org/learn">Learn</a>
          {
            mobileOnly &&
            <span
              onClick={() => handleSubmenu("learn")}
              className={handleSubMenuClass("learn")}
            />
          }
          <ul className={handleSubMenuClass("learn")}>
            <li><a href="https://www.shatterproof.org/learn/addiction-basics" target="_blank" rel="noopener noreferrer">Basics</a></li>
            <li><a href="https://www.shatterproof.org/learn/addiction-prevention" target="_blank" rel="noopener noreferrer">Prevention</a></li>
            <li><a href="https://www.shatterproof.org/learn/addiction-treatment" target="_blank" rel="noopener noreferrer">Treatment</a></li>
            <li><a href="https://www.shatterproof.org/learn/addiction-recovery" target="_blank" rel="noopener noreferrer">Recovery</a></li>
            <li><a href="https://www.shatterproof.org/learn/addiction-safety" target="_blank" rel="noopener noreferrer">Safety</a></li>
            <li><a href="https://www.shatterproof.org/learn/loss" target="_blank" rel="noopener noreferrer">Loss</a></li>
          </ul>
        </li>
        <li className="dropdown">
          <a href="https://www.shatterproof.org/find-help">Find Help</a>
          {
            mobileOnly &&
            <span
              onClick={() => handleSubmenu("findHelp")}
              className={handleSubMenuClass("findHelp")}
            />
          }
          <ul className={handleSubMenuClass("findHelp")}>
            <li><a href="https://www.shatterproof.org/find-help/dsm5-assessment" target="_blank" rel="noopener noreferrer">See if it's time to get help</a></li>
            <li><a href="https://www.shatterproof.org/find-help/determine-treatment-needs" target="_blank" rel="noopener noreferrer">Get a treatment recommendation</a></li>
            <li><a href="https://www.shatterproof.org/find-help/find-the-right-provider" target="_blank" rel="noopener noreferrer">Identify the right treatment provider</a></li>
            <li><a href="https://www.shatterproof.org/atlas" target="_blank" rel="noopener noreferrer">Find high-quality treatment</a></li>
            <li><a href="https://www.shatterproof.org/find-help/types-of-addiction-treatment" target="_blank" rel="noopener noreferrer">Learn about types of treatment</a></li>
            <li><a href="https://www.shatterproof.org/find-help/how-to-pay-for-treatment" target="_blank" rel="noopener noreferrer">Find out how to pay for treatment</a></li>
            <li><a href="https://www.shatterproof.org/find-help/prepare-for-treatment" target="_blank" rel="noopener noreferrer">Ask your network for support</a></li>
          </ul>
        </li>
        <li className="dropdown">
          <a href="https://www.shatterproof.org/get-involved">Get Involved</a>
          {
            mobileOnly &&
            <span
              onClick={() => handleSubmenu("getInvolved")}
              className={handleSubMenuClass("getInvolved")}
            />
          }
          <ul className={handleSubMenuClass("getInvolved")}>
            <li><a href="https://www.shatterproof.org/get-involved/stay-informed" target="_blank" rel="noopener noreferrer">Stay informed</a></li>
            <li><a href="https://donate.shatterproof.org/page/35108/donate/1" target="_blank" rel="noopener noreferrer">Give a monthly gift</a></li>
            <li><a href="https://p2a.co/A0VxYRC" target="_blank" rel="noopener noreferrer">Advocate for change</a></li>
            <li><a href="https://fundraise.shatterproof.org/index.cfm?fuseaction=donorDrive.event&eventID=505" target="_blank" rel="noopener noreferrer">Create a fundraiser</a></li>
            <li><a href="https://www.shatterproof.org/get-involved/become-an-ambassador" target="_blank" rel="noopener noreferrer">Become an Ambassador</a></li>
            <li><a href="https://www.shatterproof.org/get-involved/shop-our-partners" target="_blank" rel="noopener noreferrer">Shop our Partners</a></li>
            <li><a href="https://shatterproof.onlinebrandstore.net/" target="_blank" rel="noopener noreferrer">Shop with Shatterproof</a></li>
          </ul>
        </li>
        <li className="donate"><a href="https://bit.ly/3FSCCxo">Donate</a></li>
      </ul>
    </>
  )
}
